import { combineReducers } from "@reduxjs/toolkit";

// Reducers
import { viewsAdminAuditReducer } from "./admin/auditReducer";
import { viewsAdminUsersReducer } from "./admin/usersReducer";

export const viewsAdminReducer = combineReducers({
  users: viewsAdminUsersReducer,
  audit: viewsAdminAuditReducer
});
